import { Methods } from './utils/Factory'

export default {
  getEnums() {
    return Methods.get('Enum')()
  },
}
